import VueRouter from "vue-router";
import { BaseGoToHelper } from "./goToHelper";
import { $t } from "./t";

export enum InvoiceRouteNames {
  INVOICE_GROUP_TABLE = "INVOICE_GROUP_TABLE",
  INVOICE_INBOUND_TABLE = "INVOICE_INBOUND_TABLE",
  INVOICE_OUTBOUND_TABLE = "INVOICE_OUTBOUND_TABLE",
  INVOICE_DETAIL = "INVOICE_DETAIL",
  INVOICE_BILLING_DETAIL = "INVOICE_BILLING_DETAIL",
  INVOICE_BILLING_LIST = "INVOICE_BILLING_LIST",
  INVOICE_BILLING_ACCOUNT_LIST = "INVOICE_BILLING_ACCOUNT_LIST"
}

type Tab = { newTab?: boolean };
type Partner = { partnerId: string };
type Invoice = { invoiceId: string };
type Query = { query?: Record<string, string> };

export class InvoiceGoToHelper extends BaseGoToHelper {
  static get breadCrumbsInbound() {
    const locations = InvoiceGoToHelper.locations;

    return {
      InvoiceGroupTable: (data: Partner) => {
        return {
          text: $t("nav.INVOICE_GROUP_TABLE.title").toString(),
          exact: true,
          to: locations.invoiceGroupTable(data)
        };
      },
      InvoiceTable: (data: Partner) => {
        return {
          text: $t("invoice.invoices").toString(),
          exact: true,
          to: locations.invoiceInboundTable(data)
        };
      },
      InvoiceDetail: (data: Partner & Invoice) => {
        return {
          text: $t("invoice.invoice").toString(),
          exact: true,
          to: locations.invoiceDetail(data)
        };
      }
    };
  }

  static get breadCrumbsOutbound() {
    const locations = InvoiceGoToHelper.locations;

    return {
      InvoiceGroupTable: (data: Partner) => {
        return {
          text: $t("nav.INVOICE_GROUP_TABLE.title").toString(),
          exact: true,
          to: locations.invoiceGroupTable(data)
        };
      },
      InvoiceTable: (data: Partner) => {
        return {
          text: $t("invoice.invoices").toString(),
          exact: true,
          to: locations.invoiceOutboundTable(data)
        };
      },
      InvoiceDetail: (data: Partner & Invoice) => {
        return {
          text: $t("invoice.invoice").toString(),
          exact: true,
          to: locations.invoiceDetail(data)
        };
      }
    };
  }

  constructor(protected readonly router: VueRouter) {
    super(router);
  }

  static locations = {
    invoiceGroupTable: (d: Partner & Query) => {
      return {
        name: InvoiceRouteNames.INVOICE_GROUP_TABLE,
        params: { partnerId: d.partnerId },
        query: d.query
      };
    },
    invoiceInboundTable: (d: Partner & Query) => {
      return {
        name: InvoiceRouteNames.INVOICE_INBOUND_TABLE,
        params: { partnerId: d.partnerId },
        query: d.query
      };
    },
    invoiceOutboundTable: (d: Partner & Query) => {
      return {
        name: InvoiceRouteNames.INVOICE_OUTBOUND_TABLE,
        params: { partnerId: d.partnerId },
        query: d.query
      };
    },
    invoiceDetail: (d: Partner & Invoice & Query) => {
      return {
        name: InvoiceRouteNames.INVOICE_DETAIL,
        params: { partnerId: d.partnerId, invoiceId: d.invoiceId },
        query: d.query
      };
    }
  };

  goToInvoiceGroupTable(d: Tab & Partner) {
    this.go(InvoiceGoToHelper.locations.invoiceGroupTable(d), d.newTab);
  }

  goToInvoiceInboundTable(d: Tab & Partner) {
    this.go(InvoiceGoToHelper.locations.invoiceInboundTable(d), d.newTab);
  }

  goToInvoiceOutboundTable(d: Tab & Partner) {
    this.go(InvoiceGoToHelper.locations.invoiceOutboundTable(d), d.newTab);
  }

  goToInvoiceDetail(d: Tab & Partner & Invoice) {
    this.go(InvoiceGoToHelper.locations.invoiceDetail(d), d.newTab);
  }
}
